import { render } from "./LoaderMain.vue?vue&type=template&id=0354ce1b"
import script from "./LoaderMain.vue?vue&type=script&lang=js"
export * from "./LoaderMain.vue?vue&type=script&lang=js"

import "./LoaderMain.vue?vue&type=style&index=0&id=0354ce1b&lang=css"

import exportComponent from "/var/www/html/conference/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__